/**
 * Utility for managing referral codes in cookies.
 */

const REFERRAL_COOKIE_NAME = "trend_referral_code";
const REFERRER_ID_COOKIE_NAME = "trend_referrer_id";

/**
 * Sets the referral code and optionally referrer ID in cookies.
 * @param {string} code The referral code to store.
 * @param {string} referrerId The referrer ID to store.
 * @param {number} days Number of days until the cookie expires. Defaults to 30.
 */
export const setReferralCookie = (code, referrerId = null, days = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  
  const hostname = window.location.hostname;
  let domain = "";
  if (hostname.includes("trendads.ai")) {
    domain = ";domain=.trendads.ai";
  }

  document.cookie = `${REFERRAL_COOKIE_NAME}=${code};expires=${expires.toUTCString()};path=/;SameSite=Lax${domain}`;
  if (referrerId) {
    document.cookie = `${REFERRER_ID_COOKIE_NAME}=${referrerId};expires=${expires.toUTCString()};path=/;SameSite=Lax${domain}`;
  }
};

/**
 * Gets the referral code from the cookie.
 * @returns {string | null} The referral code or null if not found.
 */
export const getReferralCookie = () => {
    const name = REFERRAL_COOKIE_NAME + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return null;
};

/**
 * Gets the referrer ID from the cookie.
 * @returns {string | null} The referrer ID or null if not found.
 */
export const getReferrerIdCookie = () => {
    const name = REFERRER_ID_COOKIE_NAME + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return null;
};

/**
 * Clears the referral code and referrer ID cookies.
 */
export const clearReferralCookie = () => {
  document.cookie = `${REFERRAL_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  document.cookie = `${REFERRER_ID_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};
